import { c as _c } from "react/compiler-runtime";
import { useTruncation } from "@/hooks/use-truncation";
import { CopyButton } from "@domainstack/ui/copy-button";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
import { cn } from "@domainstack/ui/utils";
type KeyValueProps = {
  label?: string;
  value: React.ReactNode;
  copyable?: boolean;
  leading?: React.ReactNode;
  highlight?: boolean;
  trailing?: React.ReactNode;
  suffix?: React.ReactNode;
  valueTooltip?: React.ReactNode;
};
export function KeyValue(t0) {
  const $ = _c(37);
  const {
    label,
    value,
    copyable,
    leading,
    highlight,
    trailing,
    suffix,
    valueTooltip
  } = t0;
  const {
    valueRef,
    isTruncated
  } = useTruncation();
  const copyText = typeof value === "string" ? value : undefined;
  const t1 = highlight ? "border-accent-purple/20 bg-accent-purple/5 dark:border-accent-purple/12" : "border-border";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex h-16 min-w-0 items-center justify-between gap-4 rounded-xl border bg-background/60 px-4 py-3 backdrop-blur-lg", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== highlight || $[3] !== label) {
    t3 = label && <div className={cn("pt-1 text-[10px] leading-none tracking-[0.08em] uppercase", highlight ? "text-accent-purple" : "text-foreground/75 dark:text-foreground/80")}>{label}</div>;
    $[2] = highlight;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== leading) {
    t4 = leading ? <span className="h-4 w-4 rounded leading-none [&>img]:block [&>img]:h-full [&>img]:w-full [&>svg]:block [&>svg]:h-full [&>svg]:w-full">{leading}</span> : null;
    $[5] = leading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== value || $[8] !== valueRef) {
    t5 = <ResponsiveTooltipTrigger nativeButton={false} render={<span ref={valueRef} className="min-w-0 flex-1 truncate">{value}</span>} />;
    $[7] = value;
    $[8] = valueRef;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = isTruncated || valueTooltip != null ? "max-w-[80vw] break-words whitespace-pre-wrap md:max-w-[40rem]" : "hidden";
  let t7;
  if ($[10] !== t6) {
    t7 = cn(t6);
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = valueTooltip ?? value;
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <ResponsiveTooltipContent className={t7}>{t8}</ResponsiveTooltipContent>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t5 || $[16] !== t9) {
    t10 = <ResponsiveTooltip>{t5}{t9}</ResponsiveTooltip>;
    $[15] = t5;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== suffix) {
    t11 = suffix ? <span className="leading-none [&_img]:block [&_img]:h-4 [&_img]:w-4 [&_span]:leading-none [&_svg]:block [&_svg]:h-4 [&_svg]:w-4">{suffix}</span> : null;
    $[18] = suffix;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t4) {
    t12 = <div className="inline-flex min-w-0 items-center gap-1.5 text-[13px] text-foreground/95">{t4}{t10}{t11}</div>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t3) {
    t13 = <div className="flex min-w-0 flex-col space-y-1.5">{t3}{t12}</div>;
    $[24] = t12;
    $[25] = t3;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== copyText || $[28] !== copyable) {
    t14 = copyable && copyText != null && <CopyButton value={copyText} variant="ghost" className="-mr-1 text-muted-foreground" />;
    $[27] = copyText;
    $[28] = copyable;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14 || $[31] !== trailing) {
    t15 = <div className="flex shrink-0 items-center gap-2">{trailing}{t14}</div>;
    $[30] = t14;
    $[31] = trailing;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t15 || $[35] !== t2) {
    t16 = <div className={t2}>{t13}{t15}</div>;
    $[33] = t13;
    $[34] = t15;
    $[35] = t2;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}